import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

async function getEvent(eventId) {
  try {
    const event = await getDoc(doc(db, "Events", eventId));
    return event.data();
  } catch (error) {
    console.error("Erreur lors de la récupération de l'événement:", error);
  }
}

export default getEvent;
